import axios from "axios";

import { ApiService } from "../../servicios/api.service";
import LocalStorageKeys from "../../data/localStorageKeys";

export class CodigoApi {
    static endPoint = "codigos/";

    static get BasePath() {
        return ApiService.api + this.endPoint;
    }

    static get AuthHeader() {
        return "Token " + localStorage.getItem(LocalStorageKeys.token);
    }

    static get Headers() {
        return { Authorization: this.AuthHeader };
    }

    static get Config() {
        return { headers: this.Headers };
    }

    static create(data) {
        return axios.post(this.BasePath, data, this.Config);
    }

    static update(data) {
        return axios.put(this.BasePath, data, this.Config);
    }

    static deleteById(id) {
        return axios.delete(this.BasePath + id, this.Config);
    }

    static uploadFileAlta(beneficioId, formData) {
        return axios.post(
            this.BasePath + "upload-altas/" + beneficioId,
            formData,
            {
                headers: {
                    Authorization: this.AuthHeader,
                    "Content-Type": "multipart/form-data"
                }
            }
        );
    }

    static uploadFileBaja(beneficioId, formData) {
        return axios.post(
            this.BasePath + "upload-bajas/" + beneficioId,
            formData,
            {
                headers: {
                    Authorization: this.AuthHeader,
                    "Content-Type": "multipart/form-data"
                }
            }
        );
    }

}
